import { Component } from '@angular/core';
import { Nav, NavController, AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';

import { IntroSliderPage } from '../intro-slider/intro-slider';
import { RegisterPage } from '../register/register';
import { ForgotpwdPage } from '../forgotpwd/forgotpwd';
import { AppConfigProvider } from '../../providers/app-config/app-config';
import { Storage } from '@ionic/storage';
import { HomePage } from '../home/home';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  pages: Array<{ title: string; component: any }>;
  username: string;
  password: string;
  title: string;
  subtitle: string;

  constructor(
    public navCtrl: NavController,
    public nav: Nav,
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private alertCtrl: AlertController,
    private storage: Storage
  ) {
    this.pages = [
      { title: 'Intro', component: IntroSliderPage },
      { title: 'Register', component: RegisterPage },
      { title: 'Home', component: HomePage },
      { title: 'Reset Password', component: ForgotpwdPage }
    ];
  }

  login() {
    this.http
      .post(this.appConfig.apiUrl() + 'index.php/api/login/authenticate', {
        username: this.username,
        password: this.password,
        app_key: this.appConfig.appKey()
      })
      .subscribe(
        (res: any) => {
          if (res.is_login) {
            console.log(res);
            this.storage.set('token', res.token);
            this.storage.set('user_id', res.user_id);
            this.navCtrl.push(IntroSliderPage);
          } else {
            console.log('login failed.invalid user');
            this.title = 'Failed';
            this.subtitle = 'Invalid user information';
            this.alertMessage();
          }
        },
        err => {
          console.log('failed login');
          this.title = 'Failed';
          this.subtitle = 'Login process interupted';
          this.alertMessage();
        }
      );
  }

  register() {
    this.navCtrl.push(this.pages[1].component);
    // this.nav.setRoot(this.pages[1].component);
  }

  forgotpwd() {
    this.navCtrl.push(ForgotpwdPage);
  }

  alertMessage() {
    let alert = this.alertCtrl.create({
      title: this.title,
      subTitle: this.subtitle,
      buttons: ['Dismiss']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts